module.exports = __webpack_public_path__ + "static/media/web3d.052fdbc8.gif";